export const getExploreItemsTypes = {
  REQUEST: 'GET_EXPLORE_ITEMS_REQUEST',
  SUCCESS: 'GET_EXPLORE_ITEMS_SUCCESS',
  FAILED: 'GET_EXPLORE_ITEMS_FAILED',
};
